import React from 'react';
import { styles } from './FormBreak.css';

interface FormBreakProps {
  margin?: string;
  content?: string;
}

export const FormBreak = ({ margin = '', content = 'or' }: FormBreakProps): JSX.Element => {
  return (
    <div className={styles.breakContainer} style={{ margin: margin ?? '0' }}>
      <span className={styles.breakLine}>{content}</span>
    </div>
  );
};
